var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-block",class:['multi-col-grid', _vm.block.value.layout]},_vm._l((_vm.block.value.columns),function(column){return _c('div',{key:column.id,staticClass:"cms-column",class:column.id},_vm._l((column),function(block){return _c('div',[_c(_vm.getBlockComponent(block),{tag:"component",attrs:{"block":block}})],1)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }